import { combineReducers } from "@reduxjs/toolkit";
import commercialEvents from "./commercialEvents/CommercialEventsSlice";
import balanceEvents from "./BalanceEventsSlice";

export default combineReducers({
  commercialEvents,
  balanceEvents
});